import React, { memo } from 'react';

import { Arrow, ToolTipStyle } from './Tooltip.style';

function ToolTip({
  children = null,
  display = false,
}: {
  children?: React.ReactNode;
  display?: boolean;
}) {
  return (
    <ToolTipStyle data-testid="tooltip-style" visible={display}>
      <Arrow />
      {children}
    </ToolTipStyle>
  );
}

export default memo(ToolTip);
